var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5833 5.05542H24.5833C23.8925 5.05542 23.3333 5.6146 23.3333 6.30542C23.3333 6.99624 23.8925 7.55542 24.5833 7.55542H29.5833C30.2741 7.55542 30.8333 6.99624 30.8333 6.30542C30.8333 5.6146 30.2741 5.05542 29.5833 5.05542Z",
    fill: "#E77133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 0.888672H15C12.2434 0.888672 10 3.13203 10 5.88867V45.8887C10 48.6453 12.2434 50.8887 15 50.8887H35C37.7566 50.8887 40 48.6453 40 45.8887V5.88867C40 3.13203 37.7566 0.888672 35 0.888672ZM37.5 45.8887C37.5 47.2695 36.3809 48.3887 35 48.3887H15C13.6191 48.3887 12.5 47.2695 12.5 45.8887V5.88867C12.5 4.50781 13.6191 3.38867 15 3.38867H35C36.3809 3.38867 37.5 4.50781 37.5 5.88867V45.8887Z",
    fill: "#E77133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 46.7219C26.3807 46.7219 27.5 45.6026 27.5 44.2219C27.5 42.8412 26.3807 41.7219 25 41.7219C23.6193 41.7219 22.5 42.8412 22.5 44.2219C22.5 45.6026 23.6193 46.7219 25 46.7219Z",
    fill: "#E77133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4167 7.55542C21.107 7.55542 21.6667 6.99578 21.6667 6.30542C21.6667 5.61506 21.107 5.05542 20.4167 5.05542C19.7263 5.05542 19.1667 5.61506 19.1667 6.30542C19.1667 6.99578 19.7263 7.55542 20.4167 7.55542Z",
    fill: "#E77133"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.888672)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.d86cc318217e84496e4d457dd27a3e16.svg";
export { ForwardRef as ReactComponent };